import { useCallback } from 'react';
import { ApiErrorResponse } from '../common/ApiClient';
import { Modal } from '../common/components';
import { lockingErrorText } from './useLocks';
import translations from './useCheckForLockingError.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, t } = i18nNsFactory('use-check-for-locking-error');
addTranslations(translations);

const isLockingError = (error: ApiErrorResponse) => {
  if (error.response?.status === 423) {
    return { lockingError: true, message: lockingErrorText(error) };
  }

  return { lockingError: false };
};

export function useCheckForLockingError(
  objectType: string,
  navigateOnError: () => void,
) {
  return useCallback(
    (error: ApiErrorResponse) => {
      const { lockingError, message } = isLockingError(error);
      if (lockingError) {
        Modal.info({
          title: t('lock.error.content', { context: objectType }),
          content: message,
          onOk: () => navigateOnError(),
        });
        return true;
      }

      return false;
    },
    [objectType, navigateOnError],
  );
}
